import React from 'react';
import { Card, Box, Typography } from '@mui/material';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

// Function to generate random colors for line chart
const generateColor = () => {
  const r = Math.floor(Math.random() * 255);
  const g = Math.floor(Math.random() * 255);
  const b = Math.floor(Math.random() * 255);
  return `rgba(${r}, ${g}, ${b}, 0.8)`;
};

const UsersByRegions = ({ data }) => {
  // Prepare data for the line chart
  const regions = data ? Object.keys(data) : [];
  const counts = data ? Object.values(data) : [];
  
  // Generate a single color for the line
  const lineColor = generateColor();

  const chartData = {
    labels: regions,
    datasets: [
      {
        label: 'Users by Region',
        data: counts,
        borderColor: lineColor,
        backgroundColor: lineColor,
        tension: 0.4,
        fill: false,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
        labels: {
          color: '#333',
          font: {
            size: 14,
          },
        },
      },
      title: {
        display: true,
        text: 'Users by Regions',
        color: '#333',
        font: {
          size: 18,
          weight: 'bold',
        },
        padding: {
          bottom: 20,
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          precision: 0
        },
        max: Math.max(...counts) + 1
      }
    }
  };

  return (
    <Card
      sx={{
        boxShadow: 'none',
        borderRadius: '7px',
        mb: '25px',
        padding: { xs: '18px', sm: '20px', lg: '25px' },
      }}
      className="rmui-card"
    >
      <Box sx={{ mb: 2 }}>
        <Typography
          variant="h6"
          sx={{
            fontSize: 18,
            fontWeight: 600,
            mb: 2,
            textAlign: 'center',
          }}
        >
          {/* Users by Regions */}
        </Typography>
      </Box>
      <Box>
        {data && regions.length > 0 ? (
          <Line data={chartData} options={chartOptions} />
        ) : (
          <Typography variant="body1" textAlign="center">
            No data available
          </Typography>
        )}
      </Box>
    </Card>
  );
};

export default UsersByRegions;